import HCHome from "./index"
import { registerHelpCenterContext, DEFAULT_CONTEXT, DEFAULT_BASE } from "./context"

/**
 * The routes of a help center at `base` for `context`: the home, the
 * articles and categories under it, and its request form. A project serves
 * another context's help center with its own routes
 * (`...helpCenterRoutes("vendor", "/vendor/help-center")`, listed before any
 * wildcard that would take the same paths, such as "/vendor/*").
 */
export const helpCenterRoutes = (context = DEFAULT_CONTEXT, base = DEFAULT_BASE) => {
  registerHelpCenterContext(context, base)
  return {
    [base]: HCHome,
    [`${base}/submit-request`]: HCHome,
    [`${base}*`]: HCHome,
  }
}

export default helpCenterRoutes(DEFAULT_CONTEXT, DEFAULT_BASE)
